import styled from 'styled-components';
import { Col, Container, Row } from 'components/atoms/Grid';
import Colors from 'components/tokens/Colors';
import Text from 'components/atoms/Text';
import AspectRatio from 'components/atoms/AspectRatio';
import Link from 'components/atoms/Link';
import Icon, { IconRounded } from 'components/atoms/Icon';
import { sbEditable } from '@storyblok/storyblok-editable';
import VideoModal from 'containers/VideoModal';
import { useState } from 'react';
import { getAssetURL } from 'helpers/getAssetURL';
import RouterLink from 'components/atoms/RouterLink';
import { useEditor } from 'providers/generalContext';
import placeholder from 'assets/image_placeholder.png';

export default function EducationArticle(props) {
    const [openVideo, setOpenVideo] = useState(false);
    const { isStoryblokEditor } = useEditor();

    const handleOpenVideo = () => {
        setOpenVideo(true);
    };

    return (
        <>
            <MainContent {...sbEditable(props)}>
                <Container style={{ position: 'relative' }}>
                    <Row pt="8 20" pb="8 12">
                        <Col mb="3 0" size="12 5" pl="1.5 4" pr="1.5 1">
                            <Row>
                                <Col size="12">
                                    <Text size="64 72" lineHeight="56 64" title>
                                        {props?.title}
                                    </Text>
                                </Col>
                            </Row>
                        </Col>
                        <Col size="12 7" pl="1.5" pr="1.5 4" mb="5 8">
                            <Row>
                                <Col size="12" mb="3 5">
                                    {props?.description?.content[0].content?.map((paragraph, key) =>
                                        paragraph.marks ? (
                                            <Text body1 highlight key={key}>
                                                {paragraph?.text}
                                            </Text>
                                        ) : (
                                            <Text body1 key={key}>
                                                {paragraph?.text}
                                            </Text>
                                        )
                                    )}
                                </Col>
                                <Col size="12 7" {...sbEditable(props?.button[0])}>
                                    {props.button[0].link?.cached_url?.includes('http') ? (
                                        <Link
                                            href={props.button[0].link?.cached_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Text body1>{props?.button[0]?.text}</Text>
                                        </Link>
                                    ) : (
                                        <RouterLink
                                            to={`/${props.button[0].link?.cached_url}`}
                                            editor={isStoryblokEditor}
                                        >
                                            <Text body1>{props?.button[0]?.text}</Text>
                                        </RouterLink>
                                    )}
                                </Col>
                            </Row>
                        </Col>

                        {props.media?.filename && (
                            <StyledCol size="hidden 12" px="4">
                                {props.video_url && (
                                    <StyledIconRounded size="80" onClick={handleOpenVideo}>
                                        <Icon name="PlayRounded" />
                                    </StyledIconRounded>
                                )}
                                <AspectRatio
                                    noEffect
                                    cursor="pointer"
                                    ratio={56}
                                    bg={getAssetURL(props?.media?.filename) || placeholder}
                                />
                            </StyledCol>
                        )}
                        {props.media?.filename && (
                            <Col size="12 hidden" px="0">
                                {props.video_url && (
                                    <StyledIconRounded size="80" onClick={handleOpenVideo}>
                                        <Icon name="PlayRounded" />
                                    </StyledIconRounded>
                                )}

                                <AspectRatio ratio={67} bg={getAssetURL(props?.media?.filename) || placeholder} />
                            </Col>
                        )}
                    </Row>
                </Container>
            </MainContent>
            {openVideo && <VideoModal url={props.video_url} show={openVideo} onShowModal={setOpenVideo} />}
        </>
    );
}

const MainContent = styled.div`
    position: relative;
    width: 100%;
    background-color: ${Colors.white};
`;

const StyledIconRounded = styled(IconRounded)`
    cursor: pointer;
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const StyledCol = styled(Col)`
    &:hover {
        div.aspect-ratio {
            transition: filter 300ms;
            filter: brightness(50%);
        }
    }
`;
